import { pushWebEngageEvents } from "../../utils/PushEvents/WebEngage/utils"

export const sha256 = async (message: string) => {
    try {
      /* encode as UTF-8 */
      const msgBuffer = new TextEncoder().encode(message)
  
      /* hash the message */
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
  
      /* convert ArrayBuffer to Array */
      const hashArray = Array.from(new Uint8Array(hashBuffer))
  
      /* convert bytes to hex string */
      const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
      return hashHex
    } catch (e) {
      console.log('exception while encrypting', e)
      return ''
    }
  }
  
  export const pushHashedEmailIntoGtm = async (email: string) => {
    if (!email) {
      return
    }
    const hashedEmail = await sha256(email)
  
    if (hashedEmail) {
      console.log('pushed hashed email into gtm')
      window?.dataLayer?.push({
        event: 'hashedEmailReady',
        hashedEmail
      })
    }
  }